const CONTRACTOR = 'Contractor';
const CONSULTANT = 'Consultant';
const EMPLOYER = 'Employer';
const SUBCONTRACTOR = "Subcontractor";
const NOMINATED_SUBCONTRACTOR = "Nominated Subcontractor";
const SPECIALIST_SUBCONTRACTOR = "Specialist Subcontractor";
const VENDOR = "Vendor";
const PROJECT_MANAGEMENT_CONSULTANT = "Project Management Consultant";

module.exports = {
    CONTRACTOR,
    CONSULTANT,
    EMPLOYER,
    SUBCONTRACTOR,
    NOMINATED_SUBCONTRACTOR,
    SPECIALIST_SUBCONTRACTOR,
    VENDOR,
    PROJECT_MANAGEMENT_CONSULTANT,
};
 